import { formatEventUrl } from 'shared-front-end';
import styles from './EventDisplay.module.css';
import { getConfigOrThrow } from 'gossamer-front-end';

type Props = {
  eventId: number;
  eventTitle: string;
  className?: string;
};

export const EventSharing = ({ eventId, eventTitle }: Props) => {
  const eventUrl = getConfigOrThrow('main-fe-origin') + formatEventUrl(eventTitle || '', eventId);
  const message = `Check out this event on Careerbook! ${eventUrl}`;

  const sharePlatforms = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(eventUrl)}&quote=${encodeURIComponent(
      message,
    )}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`,
  };

  return (
    <div className={styles.eventInfoCard}>
      <div className={styles.leftIcon}>
        <img
          src="https://careerbook-storage.s3.us-east-1.amazonaws.com/uploads/social-media-1-1739194200353-990200389.png"
          alt="share your event"
        />
      </div>
      <div className={styles.rightBlock}>
        <div>
          <b>Share your event</b>
        </div>
        <div className={styles.eventSharing}>
          <a target="_blank" href={sharePlatforms.facebook}>
            <img src="/assets/icons/social-media-logo-facebook.svg" />
          </a>
          <a target="_blank" href={sharePlatforms.twitter}>
            <img src="/assets/icons/social-media-logo-x.svg" />
          </a>
          <a target="_blank" href={sharePlatforms.whatsapp}>
            <img src="/assets/icons/social-media-logo-whatsapp.svg" />
          </a>
          <a
            onClick={() => {
              navigator.clipboard.writeText(eventUrl);
              alert('Event link copied to clipboard!');
            }}
          >
            <img src="/assets/icons/social-media-logo-link.svg" />
          </a>
        </div>
      </div>
    </div>
  );
};
